import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BeamInspiredPage from "./components/layout/BeamInspiredPage";
import CalendlyPage from "./components/layout/calendly/calendly";
import AboutUsPage from "./components/layout/AboutUspage";
import ConstructionPage from "./components/layout/ConstructionPage";

//imports
import Gallery from "./pages/Gallery";
import PrivacyPolicyPage from "./pages/Privacy-Policy";
import TermsOfServicePage from "./pages/Terms-Service";
import CancellationPolicyPage from "./pages/Cancel-Refund";
import Events from "./pages/Events";
import Testimonials from "./pages/Testimonials";
import IVRVue from "./pages/IVRVue/IVRVue";
import IVRDATAPrivacy from "../src/components/IVRVue/IVR_DATA_privacy";
import AboutPageIVR from "./components/IVRVue/aboutus";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<BeamInspiredPage />} />
        <Route path="/cancel-refund" element={<CancellationPolicyPage />} />
        <Route path="/terms-service" element={<TermsOfServicePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

        <Route path="/book" element={<CalendlyPage />} />
        <Route path="/about-us" element={<AboutUsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/constructionpage" element={<ConstructionPage />} />
        <Route path="/events" element={<Events />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/aboutus-ivr" element={<AboutPageIVR />} />
        <Route path="/gallery" element={<Gallery />} />

        <Route path="/ivrvue" element={<IVRVue />} />
        <Route path="ivr_data_privacy" element={<IVRDATAPrivacy />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
